<template>
  <layout-basic>
      <v-container v-if="!isPartnerLevel">
        <v-row>
          <v-col class="Full-Course-Library-Title">
            My Profile
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col md="6">
            <v-form>
              <drop-zone
                :type="type"
                :accepted="accepted"
                text="Picture"
                :image.sync="company_logo"
                :dropzone-id="'profile_image'"
                class="profile-logo"
                style="padding:0px !important;text-align:center;"
              ></drop-zone>
              <v-text-field
                :error-messages="messages.first_name"
                v-model="user.first_name"
                label="My First Name"
                type="text"
                class="mt-5"
                filled
              ></v-text-field>
              <v-text-field
                :error-messages="messages.last_name"
                v-model="user.last_name"
                label="My Last Name"
                type="text"
                filled
              ></v-text-field>
              <v-text-field
                :error-messages="messages.email"
                v-model="user.email"
                label="My email"
                type="text"
                filled
              ></v-text-field>
              <!--<v-text-field
                :error-messages="messages.phone"
                v-model="user.phone"
                label="Phone (optional)"
                type="text"
                filled
              ></v-text-field>-->
            </v-form>
          </v-col>
        </v-row>
        <v-row class="mb-5">
          <v-col md="6">
             <v-btn v-if="loading" color="primary"  style="float:right;" loading></v-btn>
            <v-btn v-else
              class="btn btn-primary add-course-button text-right"
              color="primary"
              @click="updateUser"
              outlined
              style="float:right;"
            >Save</v-btn>
          </v-col>
        </v-row>
        </v-container>
        <profile-layout v-if="isPartnerLevel">
        <v-container >
        <v-row>
          <v-col class="Full-Course-Library-Title">
            My Profile
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col md="4">
            <h3>Name:</h3>
          </v-col>
          <v-col md="8" class="text-left">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{user.first_name }} {{ user.last_name }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>Email:</h3>
          </v-col>
          <v-col md="8" class="text-left">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.email }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>Company:</h3>
          </v-col>
          <v-col md="8" class="text-left" >
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.partner.data.company_name }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>Phone:</h3>
          </v-col>
          <v-col md="8" class="text-left" >
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.partner.data.phone }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>Address Line 1:</h3>
          </v-col>
          <v-col md="8" class="text-left" >
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.partner.data.address1 }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>Address Line 2:</h3>
          </v-col>
          <v-col md="8" class="text-left" >
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.partner.data.address2 }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>City:</h3>
          </v-col>
          <v-col md="8" class="text-left" >
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.partner.data.city }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h3>Postcode:</h3>
          </v-col>
          <v-col md="8" class="text-left" >
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!user.partner"></div>
            <div v-else> {{ user.partner.data.postcode }} </div>
          </v-col>
        </v-row>
        </v-container>
        </profile-layout>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import ProfileLayout from "@/layouts/Profile";
import userAPI from "@/api/user.js";
import DropZone from "@/components/global/Dropzone";
import { EventBus } from '@/event-bus.js';
export default {
  name: "Profile",
  components: {
    LayoutBasic,
    DropZone,
    ProfileLayout
  },
  data() {
    return {
      user: [],
      params: "?include=partner",
      messages: {},
      type: "company-logo",
      accepted: "image/jpg,image/jpeg,image/png",
      successMessage: "Profile Successfully Updated.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      waitMessage: "Please wait, we are uploading your image.",
      imageChanged: false,
      loading: false,
    };
  },
  computed: {
    company_logo() {
      return this.user.hasOwnProperty("company_avatar") && this.user.company_avatar!=''
              ? this.user.company_avatar
              : null;
    },
    s3Uploading() {
      //if(this.user.company_logo.url !=undefined) {
        return this.$store.getters.s3Uploading;
      //}
    },
    isPartnerLevel: function () {
      if (this.$store.getters.level == 4) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.$store.dispatch("setS3Uploading", false);
    this.getProfile();
  },
  methods: {
    getProfile() {
      this.loading = true;
      userAPI.getProfile(this.params).then(response => {
        this.loading = false;
        this.user = response.data.data;
        this.$store.dispatch('setDropzoneLoaded', { id: 'profile_image', value: true });
      });
    },
    updateUser() {
      this.loading = true;
      if (this.$store.getters.fileDetails.name != this.user.company_avatar.original_name && this.$store.getters.s3Url != '' && this.user.company_logo !== null) {
        this.$snotify.info(this.waitMessage);
      }
      userAPI
        .updateOwnerProfile(this.user.id, this.user, this.$store.getters.s3Url, this.$store.getters.fileDetails)
        .then(() => {
          // this.getProfile();
          this.loading = false;
          this.$snotify.success(this.successMessage);
          this.$store.dispatch("profile");
          this.closePanel();
          EventBus.$emit("USERS_UPDATED", this.params);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.loading = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
